/* global axios */
import ApiClient from './ApiClient';

class AccountDeletionAPI extends ApiClient {
  constructor() {
    super('account_deletion', { accountScoped: true });
  }

  mark() {
    return axios.post(this.url);
  }

  unmark() {
    return axios.delete(this.url);
  }
}

export default new AccountDeletionAPI();
